import { TokenStats } from '@/pages/api/tokens/info';
import { useQuery } from '@tanstack/react-query';

import { routes } from '@/utils/routes';

import {
  CoinGeckoCoinDataByTokenAddressResponse,
  CoingeckoTopPoolsByTokenAddressResponse,
} from '../utils/coingecko/types';
import { fetcher } from '../utils/fetcher';

type TokenInfo = {
  info: CoinGeckoCoinDataByTokenAddressResponse | undefined;
  stats: TokenStats | undefined;
  topPools: CoingeckoTopPoolsByTokenAddressResponse | undefined;
};

export const tokenInfoQueryKey = (tokenAddress: string | undefined, chainId: number | undefined) =>
  ['token-info', tokenAddress, chainId] as const;

/**
 * Fetches info about a token.
 * @param tokenAddress - The token address.
 * @param chainId - The chain ID.
 */
export const useTokenInfo = (tokenAddress: string | undefined, chainId: number | undefined) =>
  useQuery<TokenInfo, Error>({
    queryKey: tokenInfoQueryKey(tokenAddress, chainId),
    queryFn: () =>
      fetcher(`${routes.api.TOKENS_INFO}?tokenAddress=${tokenAddress}&chainId=${chainId}`),
    enabled: Boolean(tokenAddress && chainId),
    refetchOnReconnect: false,
  });
